import { IGlobalSearchResponse } from "src/api/client/search-autocomplete.api.types";

export const getCombinedResults = (results: IGlobalSearchResponse | null) => [
    ...(results?.wikifolios ?? []),
    ...(results?.underlyings ?? []),
    ...(results?.marketIndicators ?? []),
];
